import React from 'react';
import ReactDOM from 'react-dom';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import { PropTypes } from 'prop-types';
import { NormalizeClassNameString } from '../utils';

import 'react-datetime/css/react-datetime.css';
import './styles.scss';

class BasePicker extends Datetime {
	constructor(props, ...others) {
        super(props, ...others);

        this.state = {
            _inputValue: props.value instanceof moment ? props.value.clone() : props.value,
        }
        
        this.getDisplayFormat = this.getDisplayFormat.bind(this);
        this.getInputWidth = this.getInputWidth.bind(this);
        this.getDatetimeProps = this.getDatetimeProps.bind(this);

        this.inputRef = React.createRef();
        this.handleEditorValueChange = this.handleEditorValueChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    getDisplayFormat() {
        return 'L LT';
    }

    getInputWidth() {
        return null;
    }

    getDatetimeProps() {
        return null;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;
        const newValue = moment(self.props.value);
        const prevValue = moment(prevProps.value);
        const displayFormat = self.getDisplayFormat();

        let hasChanges = 
            (prevProps != self.props) &&
            (
                !newValue.isValid() || 
                !prevValue.isValid() ||
                (newValue.format(displayFormat) != prevValue.format(displayFormat))
            );

        if (hasChanges) {
            self.setState({_inputValue: newValue});
        }
    }

    handleEditorValueChange(value) {
        const self = this;

        if (value instanceof moment) {
            const ref = (self.props.inputProps || {}).ref || self.inputRef;

            if (Boolean(ref) && Boolean(ref.current) && (document.activeElement !== ref.current)) {
                //Trigger change event in case when input control does not focused
                setTimeout(() => $(ReactDOM.findDOMNode(ref.current)).trigger('change'), 0);
            }

            self.setState(
                {_inputValue: value},
                () => {
                    if (self._isMounted && (typeof self.props.onChange === 'function')) {
                        self.props.onChange(value);
                    }
                });
        }
        else {
            //self.setState({_inputValue: value});
            const allowNull = Boolean(self.props.allowNull);
            self.setState(
                {_inputValue: value},
                () => {
                    if (self._isMounted && allowNull && (typeof self.props.onChange === 'function')) {
                        self.props.onChange(null);
                    }
                });
        }
    }

    handleClose(...params) {
        const self = this;
        const {value, onClose} = self.props;

        self.setState({_inputValue: value});

        if (typeof onClose === 'function') {
            onClose(...params);
        }
    }

    render() {
        const self = this;

        const dateTimeProps = {
            closeOnSelect: true,
            ...self.getDatetimeProps(),
            onChange: self.handleEditorValueChange,
            onClose: self.handleClose,
            value: self.state._inputValue,
            //utc: false,
            strictParsing: true,
            inputProps: {...self.props.inputProps}
        };

        const props = {...self.props, ...dateTimeProps};

        const allowNull = Boolean(props.allowNull);
        props.inputProps.disabled = props.disabled;
        delete props.disabled;
        delete props.allowNull;
        
        let inputClassName = props.inputProps.className || 'form-control compact';

        if (!Boolean(self.props.disabled) && !allowNull && (!(self.state._inputValue instanceof moment) || !self.state._inputValue.isValid())) {
            inputClassName += ' is-invalid';
        }
        props.inputProps.className = NormalizeClassNameString(inputClassName);

        const inputWidth = self.getInputWidth();
        if (inputWidth != null) {
            props.inputProps.style = {width: inputWidth, ...props.inputProps.style};
        }

        if (!Boolean(props.inputProps.ref)) {
            props.inputProps.ref = self.inputRef;
        }

        return (
            <Datetime {...props} />
        )
    }
}
BasePicker.propTypes = {
    ...Datetime.propTypes,
    allowNull: PropTypes.bool,
};

BasePicker.defaultProps = {
    ...Datetime.defaultProps,
    utc: false,
    allowNull: false,
};

export class TimePicker extends BasePicker {
    getDisplayFormat() {
        return 'LT';
    }

    getInputWidth() {
        return (moment().hours(11).minutes(59).format('LT').replace(/\s/g, '').length - .5) + 'em';
    }

    getDatetimeProps() {
        return {
            dateFormat: false,
            className: this.props.className + ' timeonly'
        };
    }
}

export class DateTimePicker extends BasePicker {
    getDisplayFormat() {
        return 'L LT';
    }

    getInputWidth() {
        return null;
    }

    getDatetimeProps() {
        return {
            dateFormat: true
        };
    }
}
